import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import MediaBrowserService from '../mediaBrowser/MediaBrowserService.jsx';
import { valueForKeyPath as v } from '../../../../utils.jsx';

class PictureSizeFrame extends React.Component {
  constructor(props) {
    super(props);
    this.globalListenMouseUp = this.globalListenMouseUp.bind(this);
    this.globalListenMouseMove = this.globalListenMouseMove.bind(this);
    this.onMoveStart = this.onMoveStart.bind(this);
    this.resize = false;
    this.state = {};
  }
  componentWillMount() {
    this.setState({
      width: this.props.width,
      height: this.props.height,
      y: this.props.top,
      x: this.props.left,
      borderWidth: this.props.borderWidth,
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      width: nextProps.width,
      height: nextProps.height,
      y: nextProps.top,
      x: nextProps.left,
      borderWidth: nextProps.borderWidth,
    });
  }
  onResizeStart(x, y, event) {
    event.stopPropagation();
    this.dimensions = {
      x: x,
      y: y,
    };
    this.lastPoint = {
      x: event.screenX,
      y: event.screenY,
    };
    this.resize = true;
    window.document.addEventListener('mouseup', this.globalListenMouseUp);
    window.document.addEventListener('mousemove', this.globalListenMouseMove);
  }
  onMoveStart(event) {
    this.lastPoint = {
      x: event.screenX,
      y: event.screenY,
    };
    this.resize = false;
    window.document.addEventListener('mouseup', this.globalListenMouseUp);
    window.document.addEventListener('mousemove', this.globalListenMouseMove);
  }
  globalListenMouseUp() {
    window.document.removeEventListener(
      'mousemove',
      this.globalListenMouseMove,
    );
    window.document.removeEventListener('mouseup', this.globalListenMouseUp);
    this.props.resize({
      x: this.computePictureDimension(this.state.x, this.props.kx),
      y: this.computePictureDimension(this.state.y, this.props.ky),
      width: this.computePictureDimension(this.state.width, this.props.kx),
      height: this.computePictureDimension(this.state.height, this.props.ky),
    });
  }
  computePictureDimension(size, k) {
    return Math.round(size / k);
  }
  globalListenMouseMove(event) {
    if (this.resize) {
      this.clearSelection();
      let dx = event.screenX - this.lastPoint.x;
      let dy = event.screenY - this.lastPoint.y;
      let newHeight = this.state.height,
        newWidth = this.state.width,
        newX = this.state.x,
        newY = this.state.y;
      if (this.dimensions.x === 1) {
        newWidth += dx;
      } else if (this.dimensions.x === -1) {
        newWidth -= dx;
        newX += dx;
      }
      if (this.dimensions.y === 1) {
        newHeight += dy;
      } else if (this.dimensions.y === -1) {
        newHeight -= dy;
        newY += dy;
      }
      this.lastPoint = {
        x: event.screenX,
        y: event.screenY,
      };
      if (
        newWidth < 150 ||
        newHeight < 100 ||
        newY + newHeight > this.props.maxImageHeight ||
        newX + newWidth > this.props.maxImageWidth
      ) {
        return;
      }
      if (newY < 0 || newX < 0) {
        return;
      }
      this.setState({
        width: newWidth,
        height: newHeight,
        x: newX,
        y: newY,
      });
    } else {
      this.clearSelection();
      let dx = event.screenX - this.lastPoint.x;
      let dy = event.screenY - this.lastPoint.y;
      let newX = this.state.x;
      let newY = this.state.y;
      newX += dx;
      newY += dy;
      this.lastPoint = {
        x: event.screenX,
        y: event.screenY,
      };
      if (
        newY < 0 ||
        newX < 0 ||
        newY + this.state.height > this.props.maxImageHeight ||
        newX + this.state.width > this.props.maxImageWidth
      ) {
        return;
      }
      this.setState({
        x: newX,
        y: newY,
      });
    }
  }
  clearSelection() {
    if (document.selection) {
      document.selection.empty();
    } else if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
  }
  // onClick={this.setPhoto}
  render() {
    return (
      <div
        onMouseDown={this.onMoveStart}
        style={{
          cursor: 'move',
          border: `${this.state.borderWidth}px dashed #FF0000`,
          position: 'absolute',
          top: this.state.y,
          left: this.state.x,
          width: this.state.width,
          height: this.state.height,
        }}
      >
        <div
          onMouseDown={this.onResizeStart.bind(this, 0, -1)}
          className="top-border"
          style={{
            cursor: 'n-resize',
            position: 'absolute',
            top: 0 - this.state.borderWidth,
            left: 0,
            width: this.state.width - 2 * this.state.borderWidth + 'px',
            height: this.state.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, 0, 1)}
          className="bottom-border"
          style={{
            cursor: 's-resize',
            position: 'absolute',
            top: this.state.height - 2 * this.state.borderWidth,
            left: 0,
            width: this.state.width - 2 * this.state.borderWidth + 'px',
            height: this.state.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, -1, 0)}
          className="left-border"
          style={{
            cursor: 'w-resize',
            position: 'absolute',
            top: 0,
            left: 0 - this.state.borderWidth,
            width: this.state.borderWidth + 'px',
            height: this.state.height - 2 * this.state.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, 1, 0)}
          className="right-border"
          style={{
            cursor: 'e-resize',
            position: 'absolute',
            top: 0,
            left: this.state.width - 2 * this.state.borderWidth,
            width: this.state.borderWidth + 'px',
            height: this.state.height - 2 * this.state.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, -1, -1)}
          className="tl-corner"
          style={{
            cursor: 'nw-resize',
            position: 'absolute',
            top: 0 - this.state.borderWidth,
            left: 0 - this.state.borderWidth,
            width: this.state.borderWidth + 'px',
            height: this.state.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, -1, 1)}
          className="bl-corner"
          style={{
            cursor: 'sw-resize',
            position: 'absolute',
            top: this.state.height - 2 * this.state.borderWidth,
            left: 0 - this.state.borderWidth,
            width: this.props.borderWidth + 'px',
            height: this.props.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, 1, -1)}
          className="tr-corner"
          style={{
            cursor: 'ne-resize',
            position: 'absolute',
            top: 0 - this.state.borderWidth,
            left: this.state.width - 2 * this.state.borderWidth,
            width: this.state.borderWidth + 'px',
            height: this.state.borderWidth + 'px',
          }}
        />
        <div
          onMouseDown={this.onResizeStart.bind(this, 1, 1)}
          className="br-corner"
          style={{
            cursor: 'se-resize',
            position: 'absolute',
            top: this.state.height - 2 * this.state.borderWidth,
            left: this.state.width - 2 * this.state.borderWidth,
            width: this.state.borderWidth + 'px',
            height: this.state.borderWidth + 'px',
          }}
        />
        <span
          style={{
            background: '#FF0000',
            color: '#FFFFFF',
            padding: '5px',
            position: 'absolute',
            top: 10,
            left: 10,
          }}
        >
          [X,Y] = [{this.computePictureDimension(this.state.x, this.props.kx)},{this.computePictureDimension(
            this.state.y,
            this.props.ky,
          )}]
        </span>
        <span
          style={{
            background: '#FF0000',
            color: '#FFFFFF',
            padding: '5px',
            position: 'absolute',
            bottom: 10,
            right: 10,
          }}
        >
          [W,H] = [{this.computePictureDimension(
            this.state.width,
            this.props.kx,
          )},{this.computePictureDimension(this.state.height, this.props.ky)}]
        </span>
      </div>
    );
  }
}
PictureSizeFrame.defaultProps = {
  X: 0, // suradnica X pociatocneho bodu
  Y: 0, // suradnica Y pociatocneho bodu
  W: 0, // sirka
  H: 0, // vyska,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  borderWidth: 5,
  kx: 1,
  ky: 1,
  resize: function() {},
};

var ArticleWidgetPhoto = createReactClass({
  propTypes: {
    index: PropTypes.number,
    uri: PropTypes.string,
    uuid: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
    dimensions: PropTypes.object,
  },

  getDefaultProps: function() {
    return {
      index: 0,
      data: {
        uri: '',
        uuid: '',
        dimensions: {
          X: 0, // suradnica X pociatocneho bodu
          Y: 0, // suradnica Y pociatocneho bodu
          W: 0, // sirka
          H: 0, // vyska
        },
        crop: false,
      },
      changeObject: function() {},
    };
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  getInitialState: function() {
    return {
      loaded: false,
    };
  },

  setPhoto: function(event) {
    var _this = this;
    var onFileSelect = function(uri) {
      MediaBrowserService.closeMediaBrowser();
      var object = _this.getWidgetObject();
      object.uri = uri;
      object.dimensions = {
        X: 0,
        Y: 0,
        W: 0,
        H: 0,
      };
      object.crop = false;
      _this.props.changeObject(_this.props.index, object);
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  },

  onLoadPhoto: function(event) {
    this.setState({ loaded: true });
    var object = this.getWidgetObject();
    object.dimensions = {
      X: object.dimensions.X || 0,
      Y: object.dimensions.Y || 0,
      W: object.dimensions.W || this.image.naturalWidth,
      H: object.dimensions.H || this.image.naturalHeight,
    };
    this.props.changeObject(this.props.index, object);
  },
  onChangeDimensions: function(type, e) {
    var object = this.getWidgetObject();
    if (type === 'X') {
      object.dimensions.X = e.target.value;
    } else if (type === 'Y') {
      object.dimensions.Y = e.target.value;
    } else if (type === 'W') {
      object.dimensions.W = e.target.value;
    } else if (type === 'H') {
      object.dimensions.H = e.target.value;
    }
    this.props.changeObject(this.props.index, object);
  },
  resetDimensions: function() {
    var object = this.getWidgetObject();
    object.dimensions.X = 0;
    object.dimensions.Y = 0;
    object.dimensions.W = this.image.naturalWidth;
    object.dimensions.H = this.image.naturalHeight;
    this.props.changeObject(this.props.index, object);
  },

  getWidgetObject: function() {
    // return {type: "photo", uri: this.props.uri, uuid: this.props.uuid};
    let dimensions;
    if (this.props.data.dimensions) {
      dimensions = this.props.data.dimensions;
    } else {
      dimensions = {
        X: 0,
        Y: 0,
        W: 0,
        H: 0,
      };
    }
    return {
      type: 'photo',
      uri: v(this.props.data, 'uri'),
      description: v(this.props.data, 'description'),
      source: v(this.props.data, 'source'),
      isHidden: v(this.props.data, 'isHidden', false),
      uuid: this.props.data.uuid,
      dimensions: dimensions,
      crop: v(this.props.data, 'crop', false),
    };
  },
  resizeFrame: function(dimensions) {
    var object = this.getWidgetObject();
    object.dimensions.X = dimensions.x;
    object.dimensions.Y = dimensions.y;
    object.dimensions.W = dimensions.width;
    object.dimensions.H = dimensions.height;
    this.props.changeObject(this.props.index, object);
  },

  onChange: function(e) {
    let obj = this.getWidgetObject();
    if (e.target.name === 'isHidden') {
      obj[e.target.name] = e.target.checked;
    } else if (e.target.name === 'crop') {
      obj[e.target.name] = e.target.checked;
    } else {
      obj[e.target.name] = e.target.value;
    }
    this.props.changeObject(this.props.index, obj);
  },

  setImageCrop: function(e) {
    let obj = this.getWidgetObject();
    obj.crop = e.target.checked;
    alert(e.target.checked);
    this.props.changeObject(this.props.index, obj);
  },

  render: function() {
    var contentHtml = null;
    let uri = v(this.props.data, 'uri', '');
    if (uri === '') {
      // ak nemame uri tak zobrazime plochu pre pridanie
      contentHtml = (
        <div onClick={this.setPhoto} className="add-image">
          <i className="fa fa-plus" />
        </div>
      );
    } else {
      let dimensions;
      dimensions = {
        X: 0,
        Y: 0,
        W: 0,
        H: 0,
      };
      var areaDiv = null;
      if (this.state.loaded && this.image && this.props.data.crop) {
        let kx, ky;
        let top = 0,
          left = 0,
          width = 0,
          height = 0;
        kx = this.image.clientWidth / this.image.naturalWidth;
        ky = this.image.clientHeight / this.image.naturalHeight;
        if (typeof this.props.data.dimensions === 'object') {
          dimensions = this.props.data.dimensions;
        }
        top = dimensions.Y * ky;
        left = dimensions.X * kx;
        width = dimensions.W * kx;
        height = dimensions.H * ky;
        // areaDiv = <div onClick={this.setPhoto} style={{cursor: "pointer", border: "5px dashed #FF0000", position: "absolute", top: top, left: left, width: width, height: height}}>
        //     <span style={{background: "#FF0000", color: "#FFFFFF", padding: "5px", position: "absolute", top: 10, left: 10}}>[X,Y] = [{dimensions.X},{dimensions.Y}]</span>
        //     <span style={{background: "#FF0000", color: "#FFFFFF", padding: "5px", position: "absolute", bottom: 10, right: 10}}>[W,H] = [{dimensions.W},{dimensions.H}]</span>
        // </div>;
        areaDiv = (
          <PictureSizeFrame
            X={dimensions.X}
            Y={dimensions.Y}
            W={dimensions.W}
            H={dimensions.H}
            width={width}
            height={height}
            top={top}
            left={left}
            resize={this.resizeFrame}
            maxImageWidth={this.image.clientWidth}
            maxImageHeight={this.image.clientHeight}
            kx={kx}
            ky={ky}
          />
        );
      }
      let x, y, w, h;
      x = dimensions.X || 0;
      y = dimensions.Y || 0;
      w = dimensions.W || 0;
      h = dimensions.H || 0;

      // contentHtml = <img onClick={this.setPhoto} style={{maxWidth: "100%", margin: "0 auto", display: "block", cursor: "pointer"}} src={"/api/cm/images/fullsize/"+this.props.uri} />;
      contentHtml = (
        <div>
          <div
            className="form-group"
            style={{ position: 'relative', overflow: 'hidden' }}
          >
            <img
              ref={element => {
                this.image = element;
              }}
              onClick={this.setPhoto}
              style={{ maxWidth: '100%', display: 'block', cursor: 'pointer' }}
              src={'https://data.tvkosice.sk/cmdata/' + uri}
              onLoad={this.onLoadPhoto}
            />
            {areaDiv}
          </div>
          {/*<div className="form-group" style={{position: "relative", overflow: "hidden"}}>
                    <img ref="image" onClick={this.setPhoto} style={{maxWidth: "100%", display: "block", cursor: "pointer"}} src={"http://data.tvkosice.sk/cmdata/"+uri} onLoad={this.onLoadPhoto} />
                </div>*/}
          <div className="form-group">
            <input
              placeholder="Popis fotky"
              type="text"
              className="form-control"
              value={v(this.props.data, 'description', '')}
              name="description"
              onChange={this.onChange}
            />
          </div>
          <div className="form-group">
            <input
              placeholder="Zdroj fotky"
              type="text"
              className="form-control"
              value={v(this.props.data, 'source', '')}
              name="source"
              onChange={this.onChange}
            />
          </div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={v(this.props.data, 'crop', false)}
                  name="crop"
                  onChange={this.onChange}
                />
                Výrez fotky
              </label>
            </div>
          </div>
          {this.props.data.crop && (
            <div className="alert alert-info">
              <div className="form-group clearfix">
                Nastavujú sa súradnice počiatočného bodu [X,Y] a šírka a výška
                [W,H].
              </div>
              <div className="form-group clearfix">
                <label className="control-label col-md-2">Súradnica X:</label>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    type="number"
                    value={x}
                    onChange={this.onChangeDimensions.bind(null, 'X')}
                    style={{ width: '80px', display: 'inline' }}
                  />
                  &nbsp;px
                </div>
                <label className="control-label col-md-2">Súradnica Y:</label>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    type="number"
                    value={y}
                    onChange={this.onChangeDimensions.bind(null, 'Y')}
                    style={{ width: '80px', display: 'inline' }}
                  />
                  &nbsp;px
                </div>
              </div>
              <div className="form-group clearfix">
                <label className="control-label col-md-2">Šírka W:</label>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    type="number"
                    value={w}
                    onChange={this.onChangeDimensions.bind(null, 'W')}
                    style={{ width: '80px', display: 'inline' }}
                  />
                  &nbsp;px
                </div>
                <label className="control-label col-md-2">Výška H:</label>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    type="number"
                    value={h}
                    onChange={this.onChangeDimensions.bind(null, 'H')}
                    style={{ width: '80px', display: 'inline' }}
                  />
                  &nbsp;px
                </div>
              </div>
              <div className="form-group clearfix">
                <a
                  href="javascript:;"
                  className="btn btn-danger btn-sm"
                  onClick={this.resetDimensions}
                >
                  Reset
                </a>
              </div>
            </div>
          )}
          <div className="form-group">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={v(this.props.data, 'isHidden', false)}
                  name="isHidden"
                  onChange={this.onChange}
                />
                Skryť v obsahu
              </label>
            </div>
          </div>
          <div className="form-group clearfix">
            <a
              href="javascript:;"
              className="btn btn-primary btn-sm"
              onClick={this.setPhoto}
            >
              Vybrať nový obrázok
            </a>
          </div>
        </div>
      );
    }
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">{contentHtml}</div>
      </div>
    );
  },
});

export default ArticleWidgetPhoto;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidgetPhoto.jsx